import Acquiring from "./JS_moments/Acquiring";
import {useLocation, useNavigate} from "react-router-dom";
import React, {useState, useRef, useEffect} from "react";
import {CgArrowLeft} from "react-icons/cg";


function InstantPay() {
    const navigate = useNavigate();
    const location = useLocation();

    const [tariff, setTariff] = useState(1);
    const [subPrice, setSubPrice] = useState(150);
    const firstPrice = 1;
    const [prepaidToken, setPrepaidToken] = useState('');

    const [activeIndex, setActiveIndex] = useState(0);
    const [highlightStyle, setHighlightStyle] = useState({});
    const containerRef = useRef(null);
    const buttonsRef = useRef([]);

    const indexToTariff = [1, 6, 12];


    const [userSubscription, setUserSubscription] = useState(null);
    const [payEmail, setPayEmail] = useState(null);


    useEffect(() => {
        if (localStorage.getItem('email')) {
            const requestData = {
                uid: localStorage.getItem('uid'),
                email: localStorage.getItem('email'),
            };
            fetchLoginData(requestData);
        }
    }, []);

    useEffect(() => {
        if (userSubscription) {
            navigate('/profile')
        } else {
            setPayEmail(localStorage.getItem('email'))
        }
    }, [navigate, userSubscription]);

    const fetchLoginData = (requestData) => {
        fetch(`https://gostlink.ru/api/profile`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestData),
        })
            .then((response) => response.text())
            .then((text) => {
                if (text) {
                    const data = JSON.parse(text);
                    if (data.success) {
                        setUserSubscription(data.userInfo.subscriptionIsActive)
                    } else {
                        // Handle failure
                    }
                }
            })
            .catch((error) => {
                console.error('Fetch error:', error);
                // Handle error
            });
    };

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const token = searchParams.get('token');

        let i = parseInt(searchParams.get('i'), 10);
        if (isNaN(i)) {
            i = 5;
        }
        localStorage.setItem('i', i.toString());
        const period = Number.isInteger(i) && i >= 1 && i <= 30 ? i : 1;
        localStorage.setItem('period', period.toString());

        const validTariffs = [1, 3, 6, 12];
        let j = parseInt(searchParams.get('j') || '', 10);
        if (isNaN(j)) {
            j = 1;
        }
        localStorage.setItem('j', j.toString());
        const finalTariff = validTariffs.includes(j) ? j : 1;
        setTariff(finalTariff);
        localStorage.setItem('tariff', finalTariff.toString());

        if (token) {
            localStorage.setItem('promo', token);
        }

        // Email или уникальный идентификатор
        let email = localStorage.getItem('userEmail');
        if (!email || email === 'none') {
            generateUniqueId().then(id => {
                localStorage.setItem('userID', id);
                setPrepaidToken(id);
            });
        }

    }, [location.search]);

    useEffect(() => {
        if (tariff === 6) {
            setSubPrice(600);
            setActiveIndex(1);
        } else if (tariff === 12) {
            setSubPrice(1080);
            setActiveIndex(2)
        } else {
            setSubPrice(150);
            setActiveIndex(0)
        }

        localStorage.setItem('tariff', tariff.toString());
        localStorage.setItem('j', tariff.toString());

        // Сразу генерируем новый ID
        generateUniqueId().then(id => {
            localStorage.setItem('userID', id);
            setPrepaidToken(id);
        });

    }, [tariff]);


    async function generateUniqueId() {
        const encoder = new TextEncoder();
        const timestamp = `${Date.now()}_${performance.now()}`;
        const deviceId = navigator.userAgent;
        const raw = `${timestamp}_${deviceId}_${Math.random()}`;
        const data = encoder.encode(raw);
        const hashBuffer = await crypto.subtle.digest('SHA-256', data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hash = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

        const shortHash = hash.substring(0, 30);

        const i = localStorage.getItem('i') || '';
        const j = localStorage.getItem('j') || '';

        return `${shortHash}_${i}_${j}`;
    }

    const subSuffix = tariff === 6 ? 'полгода' : tariff === 12 ? 'год' : 'мес';


    const periods = ["Месяц", "Полгода", "Год"];


    useEffect(() => {
        if (!containerRef.current) return;
        const activeBtn = buttonsRef.current[activeIndex];
        if (activeBtn) {
            const containerRect = containerRef.current.getBoundingClientRect();
            const btnRect = activeBtn.getBoundingClientRect();

            setHighlightStyle({
                width: btnRect.width,
                left: btnRect.left - containerRect.left - 1,
            });
        }
    }, [activeIndex]);

    return (

        <div className="user-console-page">
            <div className="background-top-user-console background-main">
                <div className="gradient-top-user-console gradient-main"></div>
                {/*<div className="noise-top-user-console noise-main"/>*/}
            </div>
            <div className="background-bottom-user-console background-main">
                <div className="gradient-bottom-user-console gradient-main"></div>
                {/*<div className="noise-bottom-user-console noise-main"/>*/}
            </div>
            <div className="noise-main"/>

            <div className="user-console-content-main">

                <div className="sale-block-user-console profile-block-main">
                    <div className="title-profile-block-main">
                        <div className="group-elements-title-profile-main">
                            <div className="wrapper-title-main">
                                <h1>Оформить подписку</h1>
                            </div>
                        </div>
                        <hr/>
                    </div>
                    <div className="content-block-sale-block content-profile-block-main">
                        <div className="content-section-sale-block">
                            <table className="cost-description-sale-block">
                                <tbody>
                                <tr>
                                    <td><span>Первый платёж</span></td>
                                    <td className="cost"><span>{firstPrice} </span><span className="sub">₽</span></td>
                                </tr>

                                <tr>
                                    <td><span>Последующие платежи</span></td>
                                    <td className="cost">
                                        <span>{subPrice} </span><span className="sub">₽ / {subSuffix}</span>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="content-section-sale-block">
                            <div className="tariff-select-sale-block"
                                 ref={containerRef}
                            >
                                <div className="selected-tariff-sale-block"
                                     style={{
                                         ...highlightStyle,
                                     }}
                                />
                                {periods.map((period, i) => (
                                    <div className={`tariff-unit-sale-block ${activeIndex === i ? 'active' : ''}`}
                                         key={period}
                                         ref={(el) => {buttonsRef.current[i] = el;}}
                                         onClick={() => {
                                             const selectedTariff = indexToTariff[i];
                                             setActiveIndex(i);
                                             setTariff(selectedTariff);
                                         }}
                                    >
                                        {period}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="content-section-sale-block">
                            <div className="cost-benefits-sale-block">
                                <h1>Преимущества подписки:</h1>
                                <span>—&nbsp;&nbsp;&nbsp;Безлимит трафика</span>
                                <span>—&nbsp;&nbsp;&nbsp;Без ограничений скорости</span>
                                <span>—&nbsp;&nbsp;&nbsp;Доступ к иностранным сервисам</span>
                                <span>—&nbsp;&nbsp;&nbsp;Отсутствие рекламы</span>
                            </div>
                        </div>

                        {prepaidToken &&
                            <Acquiring
                                firstPrice={firstPrice}
                                subPrice={subPrice}
                                email={payEmail ? payEmail : ""}
                            />
                        }

                    </div>
                </div>
            </div>

            <div className="user-console-content-main" style={{padding: ' 0'}}>
                <button className="button-back-main-page button-line-main"
                        onClick={() => {
                            window.location.href = 'https://promo.gostlink.com/';
                        }}>
                    <CgArrowLeft style={{marginRight: '7px'}} size={28}/>
                    <span>
                    Вернуться
                </span>
                </button>
            </div>

            <section className="footer-section section-main" style={{paddingTop: '50px', marginTop: 'auto'}}>
                <hr/>
                <div className="content-footer">
                    <span>© 2021 — 2025&nbsp;&nbsp;&nbsp;&nbsp;ООО "Каннт"&nbsp;&nbsp;&nbsp;&nbsp;ИНН: 4011033196</span>
                    <button className="button-line-main button-footer"
                            onClick={() => {
                                navigate('/offer')
                            }}>
                        <span>
                            Публичная оферта
                        </span>
                    </button>
                </div>
            </section>
        </div>
    );
}

export default InstantPay;